/* Vitasei US — interacciones minimas, sin dependencias.
   Portado del repo headless. Las clases van con prefijo vs- para no chocar
   con Dawn; el resto de la logica es identica. */
(function () {
  'use strict';

  /* --- boton de escribir resena --------------------------------------------
     El formulario es de Judge.me y no se puede reemplazar: es el unico que
     valida la compra contra Shopify y dispara el correo de verificacion. Pero
     su boton trae su estetica, asi que su widget vive escondido y este boton
     nuestro dispara el suyo.

     El boton arranca `hidden` y solo aparece si el widget existe. Sin widget
     no abriria nada, y un boton que no hace nada es peor que no tenerlo. */
  document.querySelectorAll('[data-vs-write-review]').forEach(function (btn) {
    var suyo = document.querySelector('.jdgm-write-rev-link');
    if (!suyo) return;
    btn.hidden = false;
    btn.addEventListener('click', function () {
      suyo.click();
      var form = document.querySelector('.jdgm-form-wrapper, .jdgm-form');
      if (form) form.scrollIntoView({ block: 'center', behavior: 'smooth' });
    });
  });

  /* --- pestanas de prueba social -------------------------------------------
     Fotos y resenas escritas. Sin este script el CSS deja los dos paneles
     visibles uno debajo del otro: se pierde el gesto, no el contenido. Por eso
     la clase que los esconde la pone el script, no la hoja de estilos.

     Las imagenes del panel escondido no se descargan hasta que se abre, que es
     media razon para separarlos: son dos docenas de fotos de clientas. */
  document.querySelectorAll('[data-vs-tabs]').forEach(function (bloque) {
    var pestanas = bloque.querySelectorAll('[data-vs-tab]');
    if (pestanas.length < 2) return;
    bloque.classList.add('vs-js-on');

    pestanas.forEach(function (p) {
      p.addEventListener('click', function () {
        var id = p.getAttribute('data-vs-tab');
        pestanas.forEach(function (otra) {
          var suya = otra === p;
          otra.classList.toggle('vs-is-on', suya);
          otra.setAttribute('aria-selected', suya ? 'true' : 'false');
        });
        bloque.querySelectorAll('[data-vs-panel]').forEach(function (panel) {
          panel.classList.toggle('vs-is-on', panel.getAttribute('data-vs-panel') === id);
        });
      });
    });
  });

  /* --- selector de sabores -------------------------------------------------
     Las pastillas son enlaces de verdad al producto: sin JavaScript llevan a
     la ficha, que es un destino util. Aca se les quita ese comportamiento y
     pasan a cambiar la foto y la resena en sitio. */
  document.querySelectorAll('.vs-flavors').forEach(function (bloque) {
    var pastillas = bloque.querySelectorAll('.vs-pill--tab');
    if (pastillas.length < 2) return;

    function mostrar(id) {
      ['.vs-flavors__shot', '.vs-flavors__say', '.vs-flavors__note', '.vs-pill--tab'].forEach(function (sel) {
        bloque.querySelectorAll(sel).forEach(function (el) {
          var suyo = el.getAttribute('data-flavor') === id;
          el.classList.toggle('vs-is-on', suyo);
          if (el.matches('.vs-pill--tab')) el.setAttribute('aria-selected', suyo ? 'true' : 'false');
        });
      });
    }

    pastillas.forEach(function (p) {
      p.addEventListener('click', function (e) {
        e.preventDefault();
        mostrar(p.getAttribute('data-flavor'));
      });
    });
  });

  /* --- entradas al hacer scroll ------------------------------------------
     El CSS solo esconde el contenido si esta clase existe, o sea solo cuando
     este script llego hasta aca. Sin ella no hay animacion pero tampoco hay
     nada invisible: una pagina sin efecto es infinitamente mejor que media
     pagina en blanco.

     Ademas se marcan de una las que ya estan a la vista, en vez de esperar al
     observador: en Shopify el observador no disparaba y las 24 entradas del
     home se quedaban en opacidad cero. */
  var reveals = document.querySelectorAll('.vs-reveal');

  if (reveals.length) {
    document.documentElement.classList.add('vs-js-on');

    var showAll = function () {
      reveals.forEach(function (el) { el.classList.add('vs-is-in'); });
    };

    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) {
      showAll();
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('vs-is-in'); io.unobserve(entry.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

      reveals.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('vs-is-in');
        else io.observe(el);
      });

      /* Red de seguridad: si algo quedo sin revelar tras dos segundos, se
         muestra igual. Nada de la pagina se queda escondido por un efecto. */
      setTimeout(showAll, 2000);
    }
  }

  /* --- galeria de producto ----------------------------------------------- */
  var main = document.getElementById('vsGalleryMain');
  var thumbs = document.querySelectorAll('.vs-gallery__thumbs button');
  if (main && thumbs.length) {
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.dataset.full;
        main.removeAttribute('srcset');
        thumbs.forEach(function (b) { b.setAttribute('aria-current', String(b === btn)); });
      });
    });
  }

  /* --- el widget de Recharge no manda en nuestro formulario ---------------
     La app de Recharge inyecta su propio selector con un
     <select name="selling_plan"> DENTRO de nuestro formulario de producto.
     Como nuestros radios usan ese mismo nombre, el formulario terminaba
     mandando DOS valores y Shopify se quedaba con el primero — el de ellos.
     Resultado: el cliente elegia "3-month supply" y el checkout le cobraba
     compra unica. Verificado en la tienda, no es teorico.

     No se borra su nodo: su script lo volveria a montar y podria romperse.
     Se DESACTIVA el campo, que es lo unico que importa — un campo disabled no
     se envia — y se oculta su caja. El observer lo repite si vuelven a montar. */
  var vsForm = document.getElementById('vsProductForm');
  if (vsForm) {
    var silenceRecharge = function () {
      vsForm.querySelectorAll('[name="selling_plan"]').forEach(function (el) {
        if (el.closest('.vs-tiers')) return;          // el nuestro no se toca
        el.disabled = true;
        el.setAttribute('data-vs-silenced', 'true');
        var box = el.closest('.rc-container, .rc_container, .rc-widget, .rc_widget');
        if (box) box.style.display = 'none';
      });
    };
    silenceRecharge();
    new MutationObserver(silenceRecharge).observe(vsForm, { childList: true, subtree: true });
  }

  /* --- el carrito lateral, tambien desde nuestro formulario ----------------
     Nuestra PDP no usa el <product-form> de Dawn, asi que el submit navegaba
     a /cart en vez de abrir el panel. Se intercepta y se hace lo mismo que
     hace Dawn: pedir de paso el HTML de las secciones del carrito y dejar que
     el propio drawer se repinte y se abra. */
  function vsOpenDrawer(response) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents(response);
      return true;
    }
    return false;
  }

  var vsAddForm = document.getElementById('vsProductForm');

  /* --- la cantidad sigue al plan ------------------------------------------
     Un "3-month supply" tiene que despachar 3 frascos. Recharge lo sabe
     (product_quantity), pero los selling plans de Shopify no llevan cantidad
     y ese dato se pierde al sincronizar: el checkout entregaba uno solo con
     nombre de tres. Cada opcion trae su data-qty y aca se copia al formulario. */
  if (vsAddForm) {
    var vsQty = document.getElementById('vsQty');
    var syncQty = function () {
      if (!vsQty) return;
      var picked = vsAddForm.querySelector('.vs-tiers input[name="selling_plan"]:checked');
      vsQty.value = (picked && picked.dataset.qty) || '1';
    };
    vsAddForm.querySelectorAll('.vs-tiers input[name="selling_plan"]').forEach(function (r) {
      r.addEventListener('change', syncQty);
    });
    syncQty();
  }

  if (vsAddForm) {
    vsAddForm.addEventListener('submit', function (e) {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;                       // sin drawer, que navegue normal
      e.preventDefault();
      var btn = vsAddForm.querySelector('[name="add"]');
      if (btn) btn.setAttribute('aria-busy', 'true');

      var fd = new FormData(vsAddForm);
      fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: fd,
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) { vsAddForm.submit(); return; }   // error real: que lo muestre Shopify
          vsOpenDrawer(data);
        })
        .catch(function () { vsAddForm.submit(); })
        .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
    });
  }

  /* --- la cantidad de un "N-month supply" no se toca ----------------------
     Un plan de 9 meses trae 9 frascos con 27% de descuento. Si el cliente baja
     la cantidad a 6 en el carrito, se queda con el descuento profundo sin el
     compromiso que lo justifica — y con el de 12 meses seria 35%. El paquete
     es fijo, asi que el control de cantidad se bloquea en esas lineas.

     Esconder el control cubre a cualquiera que use la tienda. Un blindaje real
     contra alguien que llame la API a mano necesita una Shopify Function, que
     es otra pieza; queda anotado, no fingido. */
  var SUPPLY = /^(\d+)-month supply$/i;

  var vsFixing = false;

  /* Hay DOS carritos en el tema: la pagina /cart y el cajon lateral. El cajon
     se repinta entero cada vez que se abre, asi que el candado tiene que
     aplicarse en los dos y volver a aplicarse en cada repintado. Cuando solo
     se miraba `.cart-item` suelto, el cajon quedaba con los + y - vivos y el
     paquete de 9 meses se podia bajar a 1 conservando el 27%. */
  function contenedoresDeCarrito() {
    return document.querySelectorAll('.cart-items, cart-items, cart-drawer-items');
  }

  function lockSupplyQuantities() {
    if (vsFixing) return;
    var cajas = contenedoresDeCarrito();
    if (!cajas.length) return;

    var hayFilas = false;
    cajas.forEach(function (caja) { if (caja.querySelector('.cart-item')) hayFilas = true; });
    if (!hayFilas) return;

    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var wrong = null;

        cart.items.forEach(function (line, i) {
          var plan = line.selling_plan_allocation &&
                     line.selling_plan_allocation.selling_plan &&
                     line.selling_plan_allocation.selling_plan.name;
          if (!plan) return;
          var m = SUPPLY.exec(plan);
          if (!m) return;
          var debido = parseInt(m[1], 10);

          /* Esconder el control no alcanza: cuando Dawn repinta el carrito
             tras un cambio, los atributos se pierden y vuelve a ser editable.
             Por eso ademas se CORRIGE la cantidad al valor del paquete. */
          if (line.quantity !== debido && wrong === null) {
            wrong = { line: i + 1, qty: debido };
          }

          /* El indice se cuenta DENTRO de cada contenedor, no sobre todos los
             `.cart-item` de la pagina: si la pagina /cart y el cajon existen a
             la vez, un indice global desalinea las filas y el candado termina
             en la linea equivocada. */
          cajas.forEach(function (caja) {
            var row = caja.querySelectorAll('.cart-item')[i];
            if (!row) return;
            row.classList.add('vs-locked-qty');
            row.querySelectorAll('quantity-input button, .quantity__button').forEach(function (b) {
              b.disabled = true;
              b.setAttribute('aria-hidden', 'true');
            });
            row.querySelectorAll('.quantity__input').forEach(function (input) {
              input.readOnly = true;
              input.setAttribute('aria-readonly', 'true');
              input.title = plan + ' — fixed pack of ' + debido;
            });
          });
        });

        if (wrong) {
          vsFixing = true;
          fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: wrong.line, quantity: wrong.qty }),
          })
            .then(function () { window.location.reload(); })
            .catch(function () { vsFixing = false; });
        }
      })
      .catch(function () { /* si falla, el carrito sigue funcionando */ });
  }

  lockSupplyQuantities();
  ['cart:refresh', 'cart-drawer:open', 'change'].forEach(function (ev) {
    document.addEventListener(ev, lockSupplyQuantities);
  });

  /* Dawn repinta el carrito entero al cambiar una cantidad, y el cajon lateral
     ni siquiera existe en el DOM hasta que se abre por primera vez. Buscar el
     contenedor una sola vez al cargar dejaba el cajon sin vigilancia, asi que
     se observa el body.

     Con el debounce el costo es despreciable: por muchas mutaciones que dispare
     Dawn, se pide /cart.js una sola vez cada 150 ms, y solo si hay filas. */
  var pendiente = false;
  new MutationObserver(function () {
    if (pendiente || vsFixing) return;
    if (!document.querySelector('.cart-item')) return;
    pendiente = true;
    setTimeout(function () {
      pendiente = false;
      lockSupplyQuantities();
    }, 150);
  }).observe(document.body, { childList: true, subtree: true });

  /* --- constructor de la caja de colageno ---------------------------------
     A diferencia del headless, aca no se arma un permalink: se hace POST a
     /cart/add.js con todas las lineas de una, asi el carrito lateral de Dawn
     se abre solo y no hay que mantener el formato del enlace.

     El precio que se muestra es el de lista sumado. Shopify cobra cada linea
     a su precio, asi que cualquier descuento por volumen tiene que existir
     como descuento automatico en la tienda — no se finge aca. */
  var builder = document.querySelector('.vs-builder');
  if (builder) {
    var shot = document.getElementById('vsFlavorShot');
    var rows = builder.querySelectorAll('.vs-flavor');
    var giftBox = document.getElementById('vsGift');
    var giftHint = document.getElementById('vsGiftHint');
    var giftLeft = document.getElementById('vsGiftLeft');
    var cta = document.getElementById('vsBuilderCta');
    var GIFT_AT = parseInt(builder.dataset.giftAt || '3', 10);
    var MAX = parseInt(builder.dataset.max || '3', 10);
    var SUB_OFF = parseFloat(builder.dataset.sub || '15');
    var CTA_EMPTY = cta ? cta.textContent.trim() : '';
    var CTA_FULL = builder.dataset.ctaFull || 'Add to cart';

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function showFlavor(row) {
      if (!shot || !row.dataset.shot) return;
      shot.src = row.dataset.shot;
      shot.removeAttribute('srcset');
      builder.querySelectorAll('.vs-gallery__thumbs button').forEach(function (b) {
        b.setAttribute('aria-current', String(b.dataset.full === row.dataset.shot));
      });
    }

    function state() {
      var units = 0, cents = 0, lines = [];
      var pay = builder.querySelector('input[name="paying"]:checked');
      var isSub = pay && pay.value === 'sub';
      rows.forEach(function (row) {
        var n = parseInt(row.querySelector('output').textContent, 10) || 0;
        row.classList.toggle('vs-is-on', n > 0);
        if (!n) return;
        units += n;
        cents += n * parseInt(row.dataset.price, 10);
        var line = { id: row.dataset.variant, quantity: n };
        if (isSub && row.dataset.plan) line.selling_plan = parseInt(row.dataset.plan, 10);
        lines.push(line);
      });
      return { units: units, cents: cents, lines: lines };
    }

    function render() {
      var s = state();
      var once = document.getElementById('vsOnceTotal');
      var sub = document.getElementById('vsSubTotal');
      var grand = document.getElementById('vsGrandTotal');
      if (once) once.textContent = s.units ? money(s.cents) : '—';
      if (sub) sub.textContent = s.units ? money(Math.round(s.cents * (1 - SUB_OFF / 100))) : '—';

      var paying = builder.querySelector('input[name="paying"]:checked');
      var isSub = paying && paying.value === 'sub';
      if (grand) grand.textContent = money(isSub ? Math.round(s.cents * (1 - SUB_OFF / 100)) : s.cents);

      if (giftBox && giftHint) {
        var earned = !isSub && s.units >= GIFT_AT;
        giftBox.hidden = !earned;
        giftHint.hidden = earned || isSub;
        if (!earned && giftLeft) giftLeft.textContent = String(GIFT_AT - s.units);
      }

      if (cta) {
        cta.textContent = s.units ? CTA_FULL : CTA_EMPTY;
        cta.setAttribute('aria-disabled', String(s.units === 0));
      }
    }

    rows.forEach(function (row) {
      row.querySelectorAll('.vs-stepper button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var out = row.querySelector('output');
          var n = (parseInt(out.textContent, 10) || 0) + parseInt(btn.dataset.step, 10);
          var s = state();
          var otros = s.units - (parseInt(out.textContent, 10) || 0);
          out.textContent = String(Math.max(0, Math.min(n, MAX - otros)));
          showFlavor(row);
          render();
        });
      });
      /* Clic en la fila cambia la foto grande, como Ka'Chava. El stepper se
         excluye para que sumar no dispare dos cosas a la vez. */
      row.style.cursor = 'pointer';
      row.addEventListener('click', function (e) {
        if (e.target.closest('.vs-stepper')) return;
        showFlavor(row);
      });
    });

    builder.querySelectorAll('input[name="paying"]').forEach(function (r) {
      r.addEventListener('change', render);
    });

    builder.querySelectorAll('.vs-gallery__thumbs button').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!shot) return;
        shot.src = b.dataset.full;
        shot.removeAttribute('srcset');
        builder.querySelectorAll('.vs-gallery__thumbs button').forEach(function (o) {
          o.setAttribute('aria-current', String(o === b));
        });
      });
    });

    if (cta) {
      cta.addEventListener('click', function () {
        var s = state();
        if (!s.units) return;
        if (giftBox && !giftBox.hidden && giftBox.dataset.variant) {
          s.lines.push({ id: giftBox.dataset.variant, quantity: 1 });
        }
        cta.setAttribute('aria-busy', 'true');
        var drawer = document.querySelector('cart-drawer');
        var body = { items: s.lines };
        if (drawer) {
          body.sections = drawer.getSectionsToRender().map(function (x) { return x.id; });
          body.sections_url = window.location.pathname;
        }
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (!vsOpenDrawer(data)) window.location.href = window.Shopify.routes.root + 'cart';
          })
          .finally(function () { cta.removeAttribute('aria-busy'); });
      });
    }

    render();
  }

  /* --- selector de paleta -------------------------------------------------
     Escribe data-theme en <html> y lo recuerda. Es una herramienta para que
     el equipo decida el color; no es una funcion de cara al cliente. */
  var saved = null;
  try { saved = localStorage.getItem('vitasei-theme'); } catch (e) {}
  if (saved && saved !== 'ochre') document.documentElement.dataset.theme = saved;

  var swatches = document.querySelectorAll('.vs-theme button');
  swatches.forEach(function (b) {
    b.setAttribute('aria-pressed', String(b.dataset.theme === (saved || 'ochre')));
    b.addEventListener('click', function () {
      var t = b.dataset.theme;
      if (t === 'ochre') delete document.documentElement.dataset.theme;
      else document.documentElement.dataset.theme = t;
      try { localStorage.setItem('vitasei-theme', t); } catch (e) {}
      swatches.forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
    });
  });
})();
